import { user } from "./store.js";

import { auth, googleProvider } from "./firebase";
import { authState } from "rxfire/auth";

authState(auth).subscribe(user.set);

export const signout = event => auth.signOut();
export const login = () => auth.signInWithPopup(googleProvider);
